import React, { useState } from 'react';
import { FormProvider } from 'react-hook-form';

import TemplateField from 'containers/Mail/FormFields/TemplateField';
import ProjectField from 'containers/Mail/FormFields/ProjectField';
import SenderField from 'containers/Mail/FormFields/SenderField';
import ToggleMultiMode from './ToggleMultiMode';
import Recipients from './Recipients';
import SubmitForm from './SubmitForm';
import useEmailForm from './useEmailForm';
import ToggleIsMicrosoft from './ToggleIsMicrosoft';
import { useSelector } from 'react-redux';
import { getUserDetails } from 'store/selectors/auth';
import ToggleAllowDuplicates from './ToggleAllowDuplicates';
import ToggleDisableThrottling from './ToggleDisableThrottling';
import ToggleDisableTracking from './ToggleDisableTracking';

const SendEmailForm = () => {
  const user = useSelector(getUserDetails);
  const form = useEmailForm();
  const [isCsvValid, setIsCsvValid] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [selectedTemplate, setSelectedTemplate] = useState({});

  return (
    <FormProvider {...form}>
      <div className="send-mail-form exp-send-mail-form">
        {!(user.isGuest || user.projectId) && <ProjectField title="Project" />}
        <TemplateField setSelectedTemplate={setSelectedTemplate} />
        <SenderField />
        <ToggleMultiMode />
        <ToggleIsMicrosoft />
        <ToggleAllowDuplicates />
        <ToggleDisableThrottling />
        <ToggleDisableTracking
          categoryName={selectedTemplate?.category?.name}
          emailTypeId={selectedTemplate?.emailType?.id}
        />
        <Recipients
          activeTemplate={selectedTemplate}
          setIsCsvValid={setIsCsvValid}
          setTotalRows={setTotalRows}
        />
        <SubmitForm isCsvValid={isCsvValid} totalRows={totalRows} />
      </div>
    </FormProvider>
  );
};

export default SendEmailForm;
